<template>
  <component v-if="component && option"
    :is="component"
    :locale="locale"
    :lang="lang"
    :shopItemId="shopItemId"
    :shopResponsive="shopResponsive"
    :uniqueId="uniqueId"
    :optionInfo="option"
    :class="{shopOptionItem: true, isSubOption: isSubOption, isActive: activeOptionId === option.uniqueId}"
    :isSubOption="isSubOption"
    :cartOptionData="cartOptionData" />
</template>

<script>
import { getShopOptionComponent } from './OptionModules/shopOptionRegistry'

export default {
  name: 'ItemOption',
  props: [
    'locale',
    'shopResponsive',
    'uniqueId',
    'shopItemId',
    'option',
    'activeOptionId',
    'isSubOption',
    'cartOptionData'
  ],
  computed: {
    lang () {
      return this.$route.params.ln
    },
    component () {
      return getShopOptionComponent(this.option && this.option.type)
    }
  }
}
</script>
